import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import React from 'react';
import { Flex, Box, Icon } from '@qga/roo-ui/components';
import useOrigins from '@/hooks/useOrigins';
import Select from '@/components/Select';
import FormControl from '../../../FormControl';

const IconWrapper = styled(Flex)`
  pointer-events: none;
`;

const DepartingFrom = ({
  value,
  showInRow,
  icon,
  label,
  originCodes,
  onSubmit,
  error,
  calendarFocused,
}) => {
  const origins = useOrigins(originCodes).map((o) => ({
    ...o,
    name: `${o.name} - ${o.code}`,
  }));

  return (
    <Flex justifyContent="center" alignItems="center">
      {icon && <Box mr={showInRow ? 3 : null}>{icon}</Box>}
      <FormControl
        data-testid="DEPARTING_FROM"
        htmlFor="departing-from"
        label={label}
        showInRow={showInRow}
      >
        <Box position="relative">
          <Select
            data-testid="SELECT"
            mb="0"
            id="departing-from"
            value={value || ''}
            onChange={(event) => onSubmit(event.target.value)}
            error={
              (calendarFocused || error.origin) &&
              !value &&
              'Please select location'
            }
            readOnly
          >
            <option value="" disabled>
              Choose city
            </option>
            {origins.map(({ name, code }) => (
              <option key={code} value={code}>
                {name}
              </option>
            ))}
          </Select>
          <IconWrapper
            width="48px"
            position="absolute"
            top="12px"
            right="0"
            alignItems="center"
            justifyContent="center"
          >
            <Icon size={24} name="place" />
          </IconWrapper>
        </Box>
      </FormControl>
    </Flex>
  );
};

DepartingFrom.defaultProps = {
  value: undefined,
  showInRow: false,
  icon: undefined,
  label: 'Flying from',
};

DepartingFrom.propTypes = {
  value: PropTypes.string,
  label: PropTypes.string,
  showInRow: PropTypes.bool,
  icon: PropTypes.node,
  onSubmit: PropTypes.func.isRequired,
  originCodes: PropTypes.arrayOf(PropTypes.string).isRequired,
  calendarFocused: PropTypes.bool,
  error: PropTypes.shape({
    origin: PropTypes.string,
    destination: PropTypes.string,
    departureDate: PropTypes.string,
    returnDate: PropTypes.string,
    route: PropTypes.string,
  }).isRequired,
};

export default DepartingFrom;
